module.exports = __webpack_public_path__ + "img/csa_button_checkmatehero.099e0065.png";